module.exports = __webpack_public_path__ + "img/home.dd206f00.png";